import React from "react";
import dateFormat from "dateformat";
import { Link } from "react-router-dom";
const SingleItem = ({ data }) => {

    return (
        <>
            <tr>
                <td data-label="Full Name">
                    <Link to={`/agent/user/details/${data?.user_id?._id}`}>
                        <span className="fw-bold">
                            {data?.user_id?.username}
                        </span>

                    </Link>
                    <br />
                </td>

                <td data-label="TRX">
                    <strong>{data?.trx}</strong>
                </td>

                <td data-label="Transacted">
                    {dateFormat(data.createdAt, "d-m-yyyy h:MM:ss TT")}
                </td>

                <td className="budget" data-label="Amount">
                    {data.trx_type === "+" ? (
                        <span className="fw-bold text-success ">+ {data?.amount} USD</span>
                    ) : (
                        <span className="fw-bold  text--danger ">- {data?.amount} USD</span>
                    )}
                </td>

                <td className="budget" data-label="Post Balance">
                    {data?.post_balance} USD
                </td>

                <td data-label="Details">{data?.details}</td>
            </tr>
        </>
    );
};

export default SingleItem;
